module.exports = __webpack_public_path__ + "static/media/italy_paper_mill_getty_mobile.77c86b0c.jpg";